function loadLibraries() {
    window.location.replace('/adm/libraries');
}

function deleteLibraryType(id) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    ppnotify('confirm', {
        title: 'Confirm Library Type Deletion',
        text: 'Are you sure you want delete this Library Type?',
        type: 'info',
        closeOnConfirm: false,
        closeOnCancel: true,
        callback: function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/adm/library_type/' + id,
                    type: 'delete',
                    data: {
                        id: id,
                    },
                    dataType: 'json',
                    success: function (response) {
                        loadLibraries();
                        ppnotify('alert', {
                            'title': 'Success',
                            'message': 'library Type Deleted.',
                        });
                    },
                    error: function (result) {
                        ppnotify('alert', {
                            'title': 'Error',
                            'message': 'Could not delete library type.',
                        });
                    }
                });

            }
        }
    });
}


function deleteLibrary(id) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    ppnotify('confirm', {
        title: 'Confirm Library Deletion',
        text: 'Are you sure you want delete this Library?',
        type: 'info',
        closeOnConfirm: false,
        closeOnCancel: true,
        callback: function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/adm/libraries/' + id,
                    type: 'delete',
                    data: {
                        id: id,
                    },
                    dataType: 'json',
                    success: function (response) {
                        loadLibraries();
                        ppnotify('alert', {
                            'title': 'Success',
                            'message': 'library Deleted.',
                        });
                    },
                    error: function (result) {
                        ppnotify('alert', {
                            'title': 'Error',
                            'message': 'Could not delete library.',
                        });
                    }
                });

            }
        }
    });
}


function installLibrary(id) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    ppnotify('confirm', {
        title: 'Confirm Library Import',
        text: 'Are you sure you want import this library?',
        type: 'info',
        closeOnConfirm: false,
        closeOnCancel: true,
        callback: function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/adm/libraries/import/' + id,
                    type: 'post',
                    data: {
                        id: id,
                    },
                    dataType: 'json',
                    success: function (response) {
                        ppnotify('alert', {
                            'title': 'Information',
                            'type': 'info',
                            'message': response.msg,
                        });
                    },
                    error: function (result) {
                        ppnotify('alert', {
                            'title': 'Error',
                            'type': 'error',
                            'message': 'Could not install library. Please ensure the file is a properly formatted CSV file.'
                        });
                    }
                });

            }
        }
    });

}


$(document).ready(function () {

    $('#library-delete-button').click(function (e) {
        e.preventDefault();
    });

    $('#library-install-button').click(function (e){
        e.preventDefault();
    });
});

